import { Action, createSlice, PayloadAction } from "@reduxjs/toolkit"

export type DecisionOption = string | number | Action

export type DecisionContext = {
    id?: string
    title?: string
    description?: string
    options: DecisionOption[]
}

export enum DecisionStatus {
    Idle = "idle",
    Pending = "pending",
    Decided = "decided",
}

export type DecisionState = DecisionContext & {
    status: DecisionStatus
    // tracks the last decision value so it can be consumed by the calling component
    last?: DecisionOption
    // using a queue, we could easily stage multiple questions/decision in a row without too much effort, as long as the state remains relatively complexity free
    // queue: DecisionContext[]
}

const initialState: DecisionState = {
    id: undefined,
    title: undefined,
    description: undefined,
    last: undefined,
    status: DecisionStatus.Idle,
    options: [],
}

export const decisionSlice = createSlice({
    name: "decision",
    initialState,
    reducers: {
        initialized: (state: DecisionState, action: PayloadAction<DecisionContext>) => {
            const { id, title, description, options } = action.payload

            state.id = id
            state.title = title
            state.description = description
            state.options = options
            state.last = undefined
            state.status = DecisionStatus.Pending
        },
        contextCleared: (state: DecisionState) => {
            state.id = undefined
            state.title = undefined
            state.description = undefined
            state.options = []
            state.status = DecisionStatus.Idle
        },
        decided: (state: DecisionState, action: PayloadAction<DecisionOption>) => {
            state.last = action.payload
            state.status = DecisionStatus.Decided
        },
    },
})

const { actions, reducer } = decisionSlice

export const {
    decided: decidedAction,
    initialized: initializedAction,
    contextCleared: contextClearedAction,
} = actions

export default reducer
